// Imports => React
import { useRef, useMemo, memo } from 'react';
import clsx from 'clsx';

// Imports => Data
import { KEYBOARD_SHORTCUTS } from '@data/keyboard.data';

// Imports => Utilities
import { AcIsSet, AcUUID, AcIsArray } from '@opp/ui-kit';

// Imports => Atoms
import { AcRow, AcColumn, AcHeading } from '@opp/ui-kit';
import {withTranslation} from "react-i18next";

const _CLASSES = {
  MAIN: 'ac-keyboard-shortcuts-modal ac-modal-keyboard-shortcuts ac-modal--size-lg',
  GROUP: 'ac-modal-keyboard-shortcuts__group',
  TITLE: 'ac-modal-keyboard-shortcuts__title',
  LIST: {
    MAIN: 'ac-modal-keyboard-shortcuts__list',
    ITEM: 'ac-modal-keyboard-shortcuts__list__item',
    LABEL: 'ac-modal-keyboard-shortcuts__list__item-label',
    KEY: 'ac-modal-keyboard-shortcuts__list__item-key',
  },
};

const AcKeyboardShortcutsModal = ({ data = KEYBOARD_SHORTCUTS, t }) => {
  const $modal = useRef(null);

  const getListKeyClassNames = useMemo(() => {
    return clsx(_CLASSES.LIST.KEY);
  }, []);

  const getListLabelClassNames = useMemo(() => {
    return clsx(_CLASSES.LIST.LABEL);
  }, []);

  const getListItemClassNames = useMemo(() => {
    return clsx(_CLASSES.LIST.ITEM);
  }, []);

  const getListClassNames = useMemo(() => {
    return clsx(_CLASSES.LIST.MAIN);
  }, []);

  const getGroupTitleClassNames = useMemo(() => {
    return clsx(_CLASSES.TITLE);
  }, []);

  const getGroupClassNames = useMemo(() => {
    return clsx(_CLASSES.GROUP);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  }, []);

  const renderShortcuts = useMemo(() => {
    if (!AcIsSet(data)) return null;

    const collection = data;
    const len = collection.length;
    let n = 0;
    let result = [];

    for (n; n < len; n++) {
      const group = collection[n];
      const list = [];

      if (!group || Object.keys(group).length === 0) continue;

      const { title, items } = group;

      const glen = items.length;
      let g = 0;

      for (g; g < glen; g++) {
        const item = items[g];
        let keys = null;

        if (AcIsArray(item.key)) {
          keys = [];

          for (let i = 0; i < item.key.length; i++) {
            const label = item.key[i];

            const k = (
              <div
                className={getListKeyClassNames}
                key={`ac-keyboard-shortcuts-key-${g}-${i}-${label}`}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: label,
                  }}
                />
              </div>
            );

            keys.push(k);

            if (i + 1 !== item.key.length) {
              keys.push(<pre key={AcUUID()}>+</pre>);
            }
          }
        } else {
          keys = (
            <div className={getListKeyClassNames}>
              <span
                dangerouslySetInnerHTML={{
                  __html: item.key,
                }}
              />
            </div>
          );
        }

        const object = (
          <li
            key={`ac-keyboard-shortcut-${AcUUID()}`}
            className={getListItemClassNames}
          >
            <div className={getListLabelClassNames}>{t(`keyboard-shortcuts.${item.label}`, {ns: 'common'})}</div>
            <section>{keys}</section>
          </li>
        );

        list.push(object);
      }

      const col = (
        <AcColumn
          xs={12}
          sm={12}
          md={6}
          key={`ac-keyboard-shortcut-group-${AcUUID()}`}
        >
          <div className={getGroupClassNames}>
            <AcHeading rank={5} className={getGroupTitleClassNames}>
              {t(`keyboard-shortcuts.${group.title}`, {ns: 'common'})}
            </AcHeading>
            <ul className={getListClassNames}>{list}</ul>
          </div>
        </AcColumn>
      );

      result.push(col);
    }

    return result;
  }, []);

  return (
    <div className={getMainClassNames} ref={$modal}>
      <AcRow>{renderShortcuts}</AcRow>
    </div>
  );
};

export default withTranslation('common')(memo(AcKeyboardShortcutsModal));
